<template>
  <div class="wave-selector">
    <label for="wave-select">Select Wave:</label>
    <select
      id="wave-select"
      :value="$currentWave"
      class="wave-selector__dropdown"
      @change="changeWave"
    >
      <option
        v-for="wave in availableWaves"
        :key="wave"
        :value="wave"
      >
        Wave {{ wave }}
      </option>
    </select>
  </div>
</template>

<script>
import FilterMixin from '@/components/common/filter/FilterMixin.vue';

export default {
  name: 'WaveSelector',
  mixins: [FilterMixin],
  data() {
    return {
      availableWaves: [1, 2], // Add or adjust available waves as needed
    };
  },

  methods: {
    changeWave(event) {
      const waveNumber = parseInt(event.target.value, 10);
      this.$store.commit('setCurrentWave', waveNumber);
      this.countFilterValues();
    },
  },
};
</script>

<style lang="stylus" scoped>
.wave-selector {
  display: flex;
  align-items: center;
  margin: 10px 0;

  label {
    margin-right: 10px;
    color: white;
    font-weight: bold;
  }

  &__dropdown {
    padding: 5px 10px;
    border-radius: 4px;
    border: 1px solid #ccc;
    background-color: white;
    cursor: pointer;

    &:focus {
      outline: none;
      border-color: #007bff;
    }
  }
}
</style>
